import { vnextApiClient } from '@/services/vnext-api';
import { CaseParticipant, ClientTeamMember, ShareAnchor } from '@/types/report-request';

interface SharingCalls {
  list: (id: string) => Promise<CaseParticipant[]>;
  add: (id: string, email: string) => Promise<CaseParticipant>;
  remove: (id: string, participantId: string) => Promise<void>;
  teamMembers: (id: string) => Promise<ClientTeamMember[]>;
}

/** The sharing endpoints for each kind of anchor. Calls resolve the client
 * method when made, not when this table is built, so tests can mock the
 * client. */
const SHARING_CALLS: Record<ShareAnchor['kind'], SharingCalls> = {
  enquiry: {
    list: (id) => vnextApiClient.listEnquiryParticipants(id),
    add: (id, email) => vnextApiClient.addEnquiryParticipant(id, email),
    remove: (id, participantId) => vnextApiClient.removeEnquiryParticipant(id, participantId),
    teamMembers: (id) => vnextApiClient.listEnquiryTeamMembers(id),
  },
  request: {
    list: (id) => vnextApiClient.listRequestParticipants(id),
    add: (id, email) => vnextApiClient.addRequestParticipant(id, email),
    remove: (id, participantId) => vnextApiClient.removeRequestParticipant(id, participantId),
    teamMembers: (id) => vnextApiClient.listRequestTeamMembers(id),
  },
  report: {
    list: (id) => vnextApiClient.listReportParticipants(id),
    add: (id, email) => vnextApiClient.addReportParticipant(id, email),
    remove: (id, participantId) => vnextApiClient.removeReportParticipant(id, participantId),
    teamMembers: (id) => vnextApiClient.listReportTeamMembers(id),
  },
};

export function sharingCalls(kind: ShareAnchor['kind']): SharingCalls {
  return SHARING_CALLS[kind];
}
